import React, { useEffect, useState } from 'react';
import { FormControl } from 'react-bootstrap';
import { toast } from 'sonner';
import DriveFileUploader from '../../../../common/drive-file-uploader';
import AppModal from '../../../../common/AppModal';

const CancelRequestModal = ({
  service,
  orderType,
  show,
  values,
  onValuesChange,
  onHide,
  cancelRequestSubmitting,
  onSubmit
}) => {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const handleSubmit = () => {
    if (uploadedFiles.some(f => f.status === 'error')) {
      return toast.error('One or more files have failed uploading, please discard these files and try again!');
    }
    onSubmit();
  };
  useEffect(() => {
    if (show) {
      onValuesChange('fileIds', uploadedFiles.map(f => f.fileId).filter(Boolean));
    }
  }, [uploadedFiles, show]);

  useEffect(() => {
    if (!show) {
      setUploadedFiles([]);
    }
  }, [show]);

  return (
    <AppModal
      show={show}
      onHide={onHide}
      onSubmit={handleSubmit}
      heading="Cancellation Request"
      subheading={orderType}
      submitting={cancelRequestSubmitting}
      submitDisabled={uploadedFiles.some(f => f.status === 'pending' || f.status === 'UPLOADING')}
    >
      <>
        <h6 className="modal-form-label">Notes</h6>
        <FormControl
          className="app-modal-notes-input mt-0 mb-3"
          as="textarea"
          value={values?.note || ''}
          onChange={e => onValuesChange('note', e.target.value)}
          placeholder="Add a reason or any context for this cancellation..."
          size="sm"
          rows={3}
          disabled={cancelRequestSubmitting}
        />
      </>
      <DriveFileUploader
          multiple={false}
          variant="upload-area"
          uploadButtonText="Upload files"
          filesToBeUploaded={uploadedFiles}
          onUploadedFilesChange={setUploadedFiles}
          onFileSave={() => {
            toast.success('File uploaded successfully');
          }}
          deletable={false}
          folderId={service.driveFolder}
          subFolderName={orderType}
          titleClass="smallFont"
        />
    </AppModal>
  );
};

export default CancelRequestModal;
